export default {
    watch: {
        "trip.fromAddress.Address": function(newVal, oldVal) {
          this.trip.path.length = 0;
          console.log("Change");
          if (newVal !== oldVal) {
            console.log("Address changed");
          }
          this.updateTripData();
        },
    
        "trip.viaAddresses": function(newVal, oldVal) {
          if (newVal !== oldVal) {
            console.log("Via Address changed");
          }
          this.updateTripData();
        },
        "trip.toAddress.Address": function(newVal, oldVal) {
          this.trip.path.length = 0;
          if (newVal !== oldVal) {
            console.log("Address changed");
          }
          this.updateTripData();
        }
      }
}